module.exports = __webpack_public_path__ + "static/media/button.6fb58650.svg";